import apiBackend from "../apiBackend"; 


export const handleFileUpload = async (file, location,nameDoc,id,type,infoBill) => {

  const formData = new FormData();
  formData.append("pdf", file);
  formData.append("location", location);
  formData.append("nameDoc", nameDoc);

  formData.append("contactId", id);
  formData.append("type", type);
  formData.append("infoBill", JSON.stringify(infoBill));



  try {
    const user = localStorage.getItem("user");
    if (!user) return;

    const userJson = JSON.parse(user);
    const token = userJson?.accessToken;
    if (!token) return;

    const response =  await apiBackend.post("/user/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error al subir archivo:", error);
    return { error: error.message }; 
  }
};

export const fetchPDF = async (currentId) => {
  if (!currentId) return null;

  try {
    const user = localStorage.getItem("user");
    if (!user) return null;

    const userJson = JSON.parse(user);
    const token = userJson?.accessToken;
    if (!token) return null;

    const response = await apiBackend.get(`/user/get-file-pdf/${currentId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/pdf",
      },
      responseType: "blob", 
    });

    return URL.createObjectURL(response.data);
  } catch (error) {
    console.error("Error al obtener el PDF:", error);
    return null;
  }
};

export const getPdfBase64 = async (pdfId) => {
  if (!pdfId) return null;

  try {
    const user = localStorage.getItem("user");
    if (!user) return null;

    const userJson = JSON.parse(user);
    const token = userJson?.accessToken;
    if (!token) return null;

    const response = await apiBackend.get(`/user/getPdfBase64/${pdfId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/pdf",
      },
    });

    return response;
  } catch (error) {
    console.error("Error al obtener el PDF:", error);
    return null;
  }
};

export const fetchMetadataPDF = async (currentId) => {
  if (!currentId) return null;

  try {
    const user = localStorage.getItem("user");
    if (!user) return null;

    const userJson = JSON.parse(user);
    const token = userJson?.accessToken;
    if (!token) return null;

    const response = await apiBackend.get(`/user/get-metadata-file-pdf/${currentId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/pdf",
      },
    });
    return response.data
  } catch (error) {
    console.error("Error al obtener el PDF:", error);
    return null;
  }
};

export const deletePDF = async (Key) => {
  if (!Key) return false;

  try {
    const user = localStorage.getItem("user");
    if (!user) return false;

    const userJson = JSON.parse(user);
    const token = userJson?.accessToken;
    if (!token) return false;

    await apiBackend.delete(`/user/delete-file-pdf/${Key}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return true; 
  } catch (error) {
    console.error("Error al eliminar el PDF:", error);
    return false;
  }
};
